"use client";

import { ArrowRight, BadgeCheck, BookOpen, Lightbulb, ShieldCheck, Wrench, Home, Droplets, Hammer, SunMedium, Zap, Flame } from "lucide-react";
import EnTete from "@/reusable_sections/Header";
import PiedDePage from "@/reusable_sections/Footer";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const reperes = ["Guides pratiques pour mieux préparer vos travaux", "Conseils clairs pour comparer, décider et éviter les erreurs", "Accès direct aux bons formulaires quand vous êtes prêt"];
const metiersRapides = [{
  label: "Plomberie",
  slug: "plomberie",
  icon: Droplets
}, {
  label: "Electricité",
  slug: "electricite",
  icon: Zap
}, {
  label: "Maçonnerie",
  slug: "maconnerie",
  icon: Hammer
}, {
  label: "Toiture",
  slug: "couverture",
  icon: Home
}, {
  label: "Carrelage",
  slug: "carrelage",
  icon: Wrench
}, {
  label: "Menuiseries",
  slug: "menuiseries",
  icon: ShieldCheck
}];
const guides = [{
  title: "Préparer un devis travaux",
  text: "Les informations à réunir pour obtenir une réponse plus rapide et plus précise."
}, {
  title: "Comparer plusieurs propositions",
  text: "Ce qu’il faut vraiment regarder avant de choisir un artisan ou une solution."
}, {
  title: "Anticiper les points techniques",
  text: "Surface, accès, support, urgence : les détails qui changent un chantier."
}];
const themes = [{
  title: "Rénovation",
  text: "Travaux intérieurs et extérieurs pour restructurer et valoriser votre habitat.",
  icon: Home,
  href: "/demande-de-devis/renovation-interieure"
}, {
  title: "Plomberie",
  text: "Fuite, installation, débouchage ou remise en conformité.",
  icon: Droplets,
  href: "/demande-de-devis/plomberie"
}, {
  title: "Electricité",
  text: "Tableau, mise aux normes, éclairage et sécurisation.",
  icon: Zap,
  href: "/demande-de-devis/electricite"
}, {
  title: "Chauffage & PAC",
  text: "Pompes à chaleur, émetteurs, confort thermique et remplacement.",
  icon: Flame,
  href: "/demande-de-devis/chauffage"
}, {
  title: "Photovoltaïque",
  text: "Installation, autoconsommation et cadrage du projet solaire.",
  icon: SunMedium,
  href: "/demande-de-devis/photovoltaique"
}, {
  title: "Maçonnerie",
  text: "Dalles, murs, ouvertures et travaux structurels.",
  icon: Hammer,
  href: "/demande-de-devis/maconnerie"
}];
export default function ConseilsGuidesPage() {
  return <div className="bg-white text-slate-900">
      <EnTete />

      <main>
        <section className="relative overflow-hidden bg-slate-950 pt-16">
          <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{
          backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1442601/img/luxury_home_renovation_consultation_scene.png)"
        }} />
          <div className="absolute inset-0 bg-[linear-gradient(180deg,rgba(15,23,42,0.88)_0%,rgba(15,23,42,0.78)_45%,rgba(15,23,42,0.90)_100%)]" />

          <div className="relative z-10 mx-auto max-w-7xl px-4 pb-14 pt-12 sm:px-6 lg:px-8 lg:pb-18 lg:pt-24">
            <div className="max-w-4xl">
              <div className="inline-flex items-center gap-2 rounded-full border border-orange-300/30 bg-white/8 px-4 py-2 text-sm font-medium text-orange-100 backdrop-blur">
                <BadgeCheck className="h-4 w-4" />
                Conseils & Guides BE TRAVAUX
              </div>

              <h1 className="mt-6 text-3xl font-bold leading-tight text-white sm:text-5xl lg:text-6xl">
                Des conseils utiles pour mieux décider avant de lancer vos travaux.
              </h1>

              <p className="mt-5 max-w-3xl text-base leading-7 text-white/84 sm:text-xl sm:leading-8">
                Retrouvez nos repères, conseils métiers et accès directs pour passer plus sereinement du besoin
                au bon formulaire.
              </p>

              <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                <Button asChild className="h-13 rounded-2xl bg-orange-500 px-6 text-sm font-semibold text-white shadow-[0_18px_40px_rgba(249,115,22,0.28)] transition hover:bg-orange-600 sm:h-14 sm:px-7 sm:text-base">
                  <Link to="/demande-de-devis/">
                    Demander un devis
                    <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
                  </Link>
                </Button>

                <Button asChild className="h-13 rounded-2xl border border-white/18 bg-white/10 px-6 text-sm font-semibold text-white backdrop-blur transition hover:bg-white/14 sm:h-14 sm:px-7 sm:text-base">
                  <Link to="#metiers-guides">
                    Choisir un métier
                    <ArrowRight className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>
        </section>

        <section className="px-4 pt-5 sm:px-6 lg:px-8">
          <div className="mx-auto grid max-w-6xl gap-0 overflow-hidden rounded-[22px] border border-orange-100 bg-white shadow-[0_18px_50px_rgba(15,23,42,0.10)] md:grid-cols-3">
            {[["Guides pratiques", reperes[0], BookOpen], ["Décisions plus claires", reperes[1], Lightbulb], ["Passage à l’action", reperes[2], ShieldCheck]].map(([title, subtitle, Icon], index) => <div key={String(title)} className={`flex items-start gap-4 px-5 py-5 ${index < 2 ? "border-b border-orange-100 md:border-b-0 md:border-r" : ""}`}>
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-orange-50 text-orange-500">
                  <Icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="text-sm font-semibold text-slate-900">{title}</div>
                  <div className="text-sm leading-6 text-slate-500">{subtitle}</div>
                </div>
              </div>)}
          </div>
        </section>

        <section className="px-4 py-12 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <div className="mb-8 max-w-2xl">
              <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">Articles & guides travaux</h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                Une entrée plus stable, plus lisible et plus mobile-friendly pour orienter vos décisions avant de
                lancer un devis ou un dépannage.
              </p>
            </div>

            <div className="grid gap-5 lg:grid-cols-3">
              {guides.map(guide => <div key={guide.title} className="rounded-[24px] border border-slate-200 bg-white p-6 shadow-[0_14px_34px_rgba(15,23,42,0.06)]">
                  <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-orange-500">
                    <BookOpen className="h-5 w-5" />
                  </div>
                  <h3 className="mt-5 text-xl font-semibold text-slate-900">{guide.title}</h3>
                  <p className="mt-3 text-sm leading-7 text-slate-600">{guide.text}</p>
                </div>)}
            </div>
          </div>
        </section>

        <section id="metiers-guides" className="bg-slate-50 px-4 py-12 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-6xl rounded-[24px] border border-orange-100 bg-white px-5 py-6 shadow-[0_18px_50px_rgba(15,23,42,0.08)] sm:px-6">
            <div className="flex items-start gap-4">
              <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-orange-500">
                <Wrench className="h-5 w-5" />
              </div>
              <div>
                <h2 className="text-xl font-bold text-slate-900 sm:text-2xl">Accès rapide aux formulaires métiers</h2>
                <p className="mt-2 max-w-3xl text-sm leading-6 text-slate-600 sm:text-base">
                  Si vous avez déjà identifié votre besoin, utilisez directement la bonne entrée.
                </p>
              </div>
            </div>

            <div className="mt-6 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
              {metiersRapides.map(metier => {
              const Icon = metier.icon;
              return <Link key={metier.slug} to={`/demande-de-devis/${metier.slug}`} className="group flex items-center justify-between rounded-2xl border border-orange-100 bg-orange-50/45 px-4 py-4 text-slate-900 transition hover:border-orange-300 hover:bg-orange-50 focus:outline-none">
                    <div className="flex items-start gap-3">
                      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-orange-500 shadow-sm">
                        <Icon className="h-4 w-4" />
                      </span>
                      <div>
                        <div className="text-sm font-semibold">{metier.label}</div>
                        <div className="mt-1 text-xs text-slate-500">Ouvrir la bonne catégorie</div>
                      </div>
                    </div>
                    <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-white text-orange-500 shadow-sm transition group-hover:bg-orange-500 group-hover:text-white">
                      <ArrowRight className="h-4 w-4" />
                    </span>
                  </Link>;
            })}
            </div>
          </div>
        </section>

        <section className="px-4 py-12 sm:px-6 lg:px-8">
          <div className="mx-auto max-w-6xl">
            <div className="mb-8 max-w-2xl">
              <h2 className="text-3xl font-bold text-slate-900 sm:text-4xl">Explorez par thème</h2>
              <p className="mt-4 text-base leading-7 text-slate-600 sm:text-lg">
                Retrouvez les grands univers de travaux les plus consultés pour avancer plus vite.
              </p>
            </div>

            <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
              {themes.map(theme => {
              const Icon = theme.icon;
              return <Link key={theme.title} to={theme.href} className="group rounded-[24px] border border-slate-200 bg-white p-6 shadow-[0_14px_34px_rgba(15,23,42,0.06)] transition hover:-translate-y-1 hover:shadow-[0_18px_40px_rgba(15,23,42,0.10)]">
                    <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-orange-50 text-orange-500">
                      <Icon className="h-5 w-5" />
                    </div>
                    <h3 className="mt-5 text-xl font-semibold text-slate-900">{theme.title}</h3>
                    <p className="mt-3 text-sm leading-7 text-slate-600">{theme.text}</p>
                    <div className="mt-5 inline-flex items-center text-sm font-semibold text-orange-600">
                      Accéder au formulaire
                      <ArrowRight className="ml-2 h-4 w-4" />
                    </div>
                  </Link>;
            })}
            </div>
          </div>
        </section>
      </main>

      <PiedDePage />
    </div>;
}